import { Component, OnInit, HostListener, ElementRef } from '@angular/core';

import { Size } from '../../../../_models/size';
import { Update } from '../../../../_models/update';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import { CardService } from '../../card.service';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { Product } from '../../../../_models/product';
import { ApplicationNotificationService } from '../../../../shared/application-notification.service';

@Component({
  moduleId: module.id,
  selector: 'app-copy-from-product',
  templateUrl: 'copy-from-product.component.html',
  styleUrls: ['./copy-from-product.component.css']
})
export class CopyFromProductComponent implements OnInit {
  products: Observable<Product[]>;
  public copying: boolean = false;

  constructor(private cardService: CardService, public notificationService: ApplicationNotificationService) {}


  ngOnInit(): void {}

  copyValuesFromProductFromSearch(product_id:string):void {
    this.copying = true;
    this.copyValuesFromProduct(product_id).subscribe(data => {
      this.notificationService.addGrowl('Successfully copied values.');
      this.copying = !data;
    });
  }

  copyValuesFromProduct(product_id:string):Observable<boolean> {
    return this.cardService.getSizes(product_id).map(data => {
      let sizes:Size[] = data;
      for (let size of sizes) {
        for (let template of size.cards) {
          let update = new Update(template);
          this.cardService.copyUpdateToTemplate(update, size.name, template.name);
        }
      }
      return true;
    });
}

}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/copy-configuration/copy-from-product/copy-from-product.component.ts